import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import user from "./user";
import dashboard from "./dashboard";
import loading from "./loading";
import search from "./search";
import audio from "./audio";
import tracks from "./tracks";
import channels from "./channels";
import home from "./home";
import mediums from "./mediums";
import tags from "./tags";
import ads from "./ads";

export default (history) => combineReducers({
  router: connectRouter(history),
  user,
  dashboard,
  loading,
  search,
  audio,
  tracks,
  channels,
  home,
  tags,
  ads,
  mediums
});